exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".canvas-loop-move{cursor:move!important;outline:2px solid transparent!important;transition:outline-color .4s linear,transform .3s!important}.canvas-loop-move:hover{outline:2px solid rgba(8,136,200,.6)!important}", ""]);

